<template>
  <div class="flex justify-between items-center gap-2 mt-4 px-2 md:px-4">
    <div class="flex items-center gap-2">
      <select 
        :value="pageSize" 
        @change="$emit('update:pageSize', parseInt($event.target.value))"
        class="border rounded px-2 py-1 text-sm bg-white dark:bg-gray-800 dark:border-gray-600"
      >
        <option value="50">50</option>
        <option value="100">100</option>
        <option value="200">200</option>
      </select>
    </div>

    <!-- Items Info -->
<!--     <div class="flex items-center gap-2 text-sm text-gray-600 dark:text-gray-400">
      <span>
        {{ startItem }}-{{ endItem }} / {{ totalItems }} sipariş gösteriliyor
      </span>
    </div> -->

    <!-- Pagination Controls -->
    <div class="flex items-center gap-2">
      <button @click="$emit('prev-page')" :disabled="currentPage === 1" class="p-2 rounded border disabled:opacity-50">
        <ArrowLeftIcon class=" h-3 w-3 md:w-4 md:h-4 text-gray-500 hover:text-secondary-text" />
      </button>

      <button v-for="page in visiblePages" :key="page" @click="page !== '...' && $emit('go-to-page', page)"
        :disabled="page === '...'"
        :class="['px-3 py-1 border rounded text-sm', currentPage === page ? 'bg-gray-200 text-black' : '', page === '...' ? 'cursor-default text-gray-400' : '']">
        {{ page }}
      </button>

      <button @click="$emit('next-page')" :disabled="currentPage === totalPages"
        class="p-2 rounded border disabled:opacity-50">
        <ArrowRightIcon class=" h-3 w-3 md:w-4 md:h-4 text-gray-500 hover:text-secondary-text" />
      </button>
    </div>
  </div>
</template>

<script>
import { ArrowLeftIcon, ArrowRightIcon } from '@heroicons/vue/24/outline';

export default {
  name: 'AppPagination',
  components: {
    ArrowLeftIcon,
    ArrowRightIcon
  },
  props: {
    currentPage: {
      type: Number,
      required: true
    },
    totalPages: {
      type: Number,
      required: true
    },
    pageSize: {
      type: Number,
      required: true
    },
    totalItems: {
      type: Number,
      required: true
    }
  },
  computed: {
    startItem() {
      if (this.totalItems === 0) return 0;
      return (this.currentPage - 1) * this.pageSize + 1;
    },
    endItem() {
      if (this.totalItems === 0) return 0;
      return Math.min(this.currentPage * this.pageSize, this.totalItems);
    },
    visiblePages() {
      const total = this.totalPages;
      const current = this.currentPage;
      const pages = [];

      if (total <= 5) {
        for (let i = 1; i <= total; i++) {
          pages.push(i);
        }
      } else {
        pages.push(1);

        if (current > 3) pages.push('...');

        const start = Math.max(2, current - 1);
        const end = Math.min(total - 1, current + 1);

        for (let i = start; i <= end; i++) {
          pages.push(i);
        }

        if (current < total - 2) pages.push('...');

        pages.push(total);
      }

      return pages;
    }

  }
};
</script>